import React, { useEffect, useState } from "react";
import spinner from "../../assets/img/icons/common/Spinner@1x-1.0s-200px-200px.svg";
import { useNavigate } from "react-router-dom";

export default function SpinnerWheel({ interval = 1000, navigateTo = "/", shouldNavigate = true }) {
    const [showImg, setShowImg] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (shouldNavigate) {
            setTimeout(() => {
                setShowImg(false);
                navigate(navigateTo);
            }, interval);
        }
    }, []);

    return (
        <>
            <div>
                {showImg ? <div className="text-center"><img alt="spinner" src={spinner} /></div> : ""}
            </div>
        </>
        
    );
}